import React, { useEffect } from 'react';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import MovieIcon from '@material-ui/icons/Movie';
import SearchIcon from '@material-ui/icons/Search';
import TvIcon from '@material-ui/icons/Tv';
import { makeStyles } from "@material-ui/core/styles";
import { useNavigate } from 'react-router-dom';


const useStyles = makeStyles({
  root: {
    width: '100%',
    position: 'fixed',
    bottom: 0, 
    backgroundColor: "#F0F8FF",
    zIndex: 100,
  },
});

export default function SimpleBottomNavigation() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const navigate = useNavigate();

  useEffect(() => {
      if (value ===0) navigate("/");
      else if (value ===1) navigate("/movies");
      else if (value ===2) navigate("/series");
      else if (value ===3) navigate("/search");
  }, [value, navigate]);

  return (
    <BottomNavigation
      value={value}
      onChange={(event, newValue) => {
        setValue(newValue);
        }}
        showLabels
        className={classes.root}
      >
        <BottomNavigationAction 
          style={{ color: "Black" }}
          label="Trending" 
          icon={<WhatshotIcon />} 
        />
        <BottomNavigationAction
          style={{ color: "Black" }}
          label="Movies" 
          icon={<MovieIcon />} 
        />
        <BottomNavigationAction
          style={{ color: "Black" }}
          label="TV Series" 
          icon={<TvIcon />} 
        />
        <BottomNavigationAction
          style={{ color: "Black" }}
          label="Search" 
          icon={<SearchIcon />} 
        />
      </BottomNavigation>
  );
}